import 'date-fns';
import React, {useMemo, useState} from 'react';
import {Button, Col, Container, Row} from "react-bootstrap";
import {Dialog, DialogActions, DialogContent, DialogTitle,} from "@material-ui/core";
import DatePicker from "react-datepicker";
import Select from "react-select";
import {
    FILTER_STATUS_ALL,
    FILTER_STATUS_CLOSED,
    FILTER_STATUS_IN_SHIPPING, FILTER_STATUS_NEW,
    FILTER_STATUS_PENDING,
    FILTER_STATUS_SHIPPED,
    FILTER_INITIAL_STATE
} from "../constants";
import useUserList from "../../../shared/functions/useUserList";
import useVendorList from "../../../shared/functions/useVendorList";


const statuses = [
    {value: FILTER_STATUS_ALL, label: 'All'},
    {value: FILTER_STATUS_PENDING, label: 'Pending'},
    {value: FILTER_STATUS_CLOSED, label: 'Closed'},
    {value: FILTER_STATUS_IN_SHIPPING, label: 'InShipping'},
    {value: FILTER_STATUS_SHIPPED, label: 'Shipped'},
    {value: FILTER_STATUS_NEW, label: 'New'},
]

export default function FilterModal({show, onSet, onClose}) {

    const [filter, setFilter] = useState(FILTER_INITIAL_STATE)
    const [selectedVendor, setSelectedVendor] = useState(null);
    const [selectedLocation, setSelectedLocation] = useState(null);

    const {users: userList, isLoading: isUsersFetchingPending} = useUserList();
    const {vendors: vendorList, isLoading:isVendorsFetchingLoading} = useVendorList();

    const users = useMemo(() => {
        return (userList && userList.map((user) => ({value: user.id, label: user.name}))) ?? []
    }, [userList]);

    const vendors = useMemo(() => {
        return (vendorList && vendorList.map(vendor => ({value: vendor.id, label: vendor.Name}))) ?? []
    }, [vendorList])

    const locations = useMemo(() => {
        const selectedVendor = filter.delivery.vendor;
        const list = (selectedVendor && vendorList.find(vendor => vendor.id === selectedVendor.id)?.Stores) ?? [];
        return list.map(local => ({value: `asd-${local.Name}`, label: local.Name}))
    }, [filter,vendorList])

    //######################################################
    const handleStatusChange = (status) => {
        setFilter({...filter, status: status})
    }

    //######################################################
    const handleStartDateChange = (date) => {
        setFilter({...filter, date: {...filter.date, start: date}})
    }

    const handleEndDateChange = (date) => {
        setFilter({...filter, date: {...filter.date, end: date}})
    }

    //######################################################
    const handleUserChange = (user) => {
        user && setFilter({...filter, user: {id: user.value, name: user.label}})
        !user && setFilter({...filter, user: null})
    }

    //######################################################

    const handleVendorChange = (vendor) => {
        vendor && setFilter({...filter, delivery: {...filter.delivery, vendor: {id: vendor.value, name: vendor.label}}})
        vendor && setSelectedVendor(vendor);
        !vendor && setFilter({...filter, delivery: {location: null, vendor: null}})
        !vendor && setSelectedLocation(null);
        !vendor && setSelectedVendor(null);
    }

    const handleLocationChange = (location) => {
        setSelectedLocation(location);
        location && setFilter({
            ...filter,
            delivery: {...filter.delivery, location: location.label}
        })
        !location && setFilter({...filter, delivery: {...filter.delivery, vendor: null}})
    }

    //######################################################
    const handleApplying = () => {
        onSet && onSet(filter)
        handleModalClosing()
    }

    const handleReset = () => {
        setFilter(FILTER_INITIAL_STATE);
        setSelectedLocation(null);
        setSelectedVendor(null);
    }

    const handleModalClosing = () => {
        onClose && onClose()
    }


    return (
        <Dialog fullWidth maxWidth='sm' open={show} onClose={handleModalClosing}>
            <DialogTitle>
                Filter
            </DialogTitle>

            <DialogContent>

                {/*___Status___*/}
                <Container className='ml-2'>
                    <Row>
                        <h6>By status</h6>
                    </Row>

                    <Select
                        options={statuses}
                        value={statuses.find(one => one.value === filter.status) ?? statuses[0]}
                        isSearchable={true}
                        onChange={selected => handleStatusChange((selected && selected.value) ?? null)}
                    />

                </Container>

                <div style={{margin: 20}}/>

                {/*___Date___*/}
                <Container className='ml-2'>
                    <Row>
                        <h6>By date</h6>
                    </Row>

                    <div style={{margin: 3}}/>

                    <Row>

                        <Col>
                            <Row className='ml-1'>
                                Debut
                            </Row>
                            <DatePicker
                                style={{position: 'absolute', zIndex: 30000}}
                                selected={filter.date.start}
                                onChange={handleStartDateChange}
                                className={'form-control ml-0'}
                                dateFormat={'dd-MM-yyyy'}
                                isClearable
                                placeholderText="I have been cleared!"
                            />
                        </Col>

                        <Col>
                            <Row className='ml-1'>
                                Fin
                            </Row>
                            <DatePicker
                                style={{position: 'absolute', zIndex: 30000}}
                                selected={filter.date.end}
                                onChange={handleEndDateChange}
                                className={'form-control ml-0'}
                                dateFormat={'dd-MM-yyyy'}
                                isClearable
                                placeholderText="I have been cleared!"
                            />
                        </Col>

                    </Row>
                </Container>

                <div style={{margin: 20}}/>

                {/*___User___*/}
                <Container className='ml-2'>
                    <Row>
                        <h6>By user</h6>
                    </Row>
                    <Select

                        options={users}
                        value={(filter.user && users && users.find(one => one.value === filter.user.id))}
                        isLoading={isUsersFetchingPending}
                        isClearable={true}
                        isSearchable={true}
                        onChange={handleUserChange}
                    />
                </Container>

                <div style={{margin: 20}}/>

                {/*___Vendor and location___*/}
                <Container className='ml-2'>
                    <Row>
                        <h6>By vendor and location</h6>
                    </Row>

                    <div style={{margin: 3}}/>

                    <Row>
                        <Col md={5}>
                            <Row className='ml-1'>
                                Vendor
                            </Row>
                            <Select
                                isLoading={isVendorsFetchingLoading}
                                isClearable={true}
                                isSearchable={true}
                                value={selectedVendor}
                                options={vendors}
                                style={{width: 400}}
                                onChange={handleVendorChange}

                            />
                        </Col>

                        <Col md={5}>
                            <Row className='ml-1'>
                                Location
                            </Row>
                            <Select
                                isLoading={isVendorsFetchingLoading}
                                isClearable={true}
                                isSearchable={true}
                                value={selectedLocation}
                                options={locations}
                                style={{width: 400}}
                                onChange={handleLocationChange}

                            />
                        </Col>
                    </Row>

                </Container>

                <div style={{height: 200}}/>


            </DialogContent>

            <DialogActions>
                <Button onClick={handleApplying}> Apply </Button>
                <Button className='btn-dark' onClick={handleReset}> Reset </Button>
                <Button variant='outline-secondary' onClick={handleModalClosing}> Close </Button>
            </DialogActions>

        </Dialog>
    )
}
